export default {
  title: "取消订阅",
  processing: "正在处理您的取消订阅请求...",
  success_title: "取消订阅成功",
  success_message: "您已成功从我们的邮件列表中取消订阅。",
  error_title: "取消订阅失败",
  error_message: "我们无法处理您的取消订阅请求。请稍后再试。",
  go_home: "返回首页",
};
